import React from 'react'
import M from 'materialize-css'
import { Link } from 'react-router-dom'
import backgroundImage from '../../config/logo1.png'

const Policy = function (props) {

    React.useEffect(function () {
        document.title = 'Service Policy'
        M.AutoInit()
        return function () { }
        // eslint-disable-next-line
    }, [])

    return (
        <main>
        <div
                className='background-image'
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    opacity: 0.2,
                    zIndex: -1,
                }}
            >
            </div>
            <div className='row' style={{ marginTop: "2rem" }}>
                <div className='col s12 m10 offset-m1'>
                    <Link to={'/'} className='btn-small red'>Go back home</Link>
                    <h5>
                        <i>
                            This feauture is currently on development it will be available very soon.
                        </i>
                    </h5>
                </div>
            </div>
        </main>
    )
}

export default React.memo(Policy)